import _ from 'lodash';

import store from '../store';

import { dimensions } from '../data/dimensions';

export function localizeToString(activeLocalization, localizeKeyOrKeys, defaultValue = ''){

  if(!activeLocalization){
    return defaultValue;
  }

  let localizedText = false;

  if(typeof localizeKeyOrKeys === 'string'){
    localizedText = activeLocalization[localizeKeyOrKeys];
  }
  else if(typeof localizeKeyOrKeys === 'object'){
    let localized = false;

    _.each(localizeKeyOrKeys, keyToCheck => {
      if(!localized && activeLocalization[keyToCheck]){
        localizedText = activeLocalization[keyToCheck];
        localized = true;
      }
    });
  }

  return localizedText || defaultValue;
}

function getDefaultCategoryLabelFromId(categoryId){
  switch(categoryId){
    default:
      return undefined;
    case 1:
    case '1':
      return 'Motivation';
    case 2:
    case '2':
      return 'Interaction';
    case 3:
    case '3':
      return 'Cognition';
    case 4:
    case '4':
      return 'Execution';
  }
}

export function getDefaultDimensionLabelFromId(dimensionId){
  return dimensions[dimensionId].label;
}

export function getDefaultDimensionDefinitionFromId(dimensionId){
  return dimensions[dimensionId].definition;
}

export function getDefaultDimensionCompetencyDefinitionFromId(dimensionId){
  return dimensions[dimensionId].competencyDescription;
}

export function getDefaultDimensionleadingDescriptionFromId(dimensionId){
  return dimensions[dimensionId].leadingDescription;
}

//TODO add optional language param
function getDefaultLocalization(key){
  switch(key){
    default: return 'Missing Translation';

    //sprint terminology
    case 'outcome_best_prediction': return 'Best Prediction';
    case 'outcome_low_prediction': return 'Worst Case';
    case 'outcome_high_prediction': return 'Best Case';
    case 'outcome_range_label': return 'Range';
  }
}

export function localize(key, localizations, language = 'default'){
  // console.log('localize: ', key, localizations, language);

  if(localizations && localizations[language] && localizations[language][key]){
    return localizations[language][key];
  }
  else{
    return getDefaultLocalization(key);
  }
}

export function localizeDimensionCategory({categoryId, orgLocaliztions, appLocalizations, language = 'default'}){
  if(
    orgLocaliztions &&
    orgLocaliztions[language] &&
    orgLocaliztions[language]['categories'] &&
    orgLocaliztions[language]['categories'][categoryId]
  ){
    return orgLocaliztions[language]['categories'][categoryId];
  }
  else if(
    appLocalizations &&
    appLocalizations[language] &&
    appLocalizations[language]['categories'] &&
    appLocalizations[language]['categories'][categoryId]
  ){
    return appLocalizations[language]['categories'][categoryId];
  }
  else{
    return getDefaultCategoryLabelFromId(categoryId);
  }
}

export function localizeProfile({profileId, orgLocaliztions, appLocalizations, language = 'default'}){
  if(
    orgLocaliztions &&
    orgLocaliztions[language] &&
    orgLocaliztions[language]['talent_profiles'] &&
    orgLocaliztions[language]['talent_profiles'][profileId]
  ){
    return orgLocaliztions[language]['talent_profiles'][profileId];
  }
  else if(
    appLocalizations &&
    appLocalizations[language] &&
    appLocalizations[language]['talent_profiles'] &&
    appLocalizations[language]['talent_profiles'][profileId]
  ){
    return appLocalizations[language]['talent_profiles'][profileId];
  }
  else{
    return false;
  }
}

export function localizeDimension({dimensionId, profileId = 'default', orgLocaliztions, appLocalizations, language = 'default'}){
  if(
    orgLocaliztions &&
    orgLocaliztions[language] &&
    orgLocaliztions[language]['dimensions'] &&
    orgLocaliztions[language]['dimensions'][dimensionId] &&
    orgLocaliztions[language]['dimensions'][dimensionId][profileId]
  ){
    return orgLocaliztions[language]['dimensions'][dimensionId][profileId];
  }
  else if(
    appLocalizations &&
    appLocalizations[language] &&
    appLocalizations[language]['dimensions'] &&
    appLocalizations[language]['dimensions'][dimensionId] &&
    appLocalizations[language]['dimensions'][dimensionId][profileId]
  ){
    return appLocalizations[language]['dimensions'][dimensionId][profileId];
  }
  else{
    return getDefaultDimensionLabelFromId(dimensionId);
  }
}



// WEBPACK FOOTER //
// ./src/util/localizers.js